/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {applyMiddleware, createStore} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import thunk from 'redux-thunk';

const initialState = {};

const composeEnhancers = composeWithDevTools({
  name : process.env.APP_NAME
});

/**
 * Provides a utility for initializing an Application's Redux Store based on an optional
 * preloaded state, and the root reducer which provides all application reducer state.
 *
 * @param   rootReducer Defines the application's root reducer for which the store is to be
 *          initialized.
 * @param   preloadedState Provides the initial application state, defaults to an empty object.
 * @returns The application Redux Store instance
 */
export const initializeStore = (rootReducer: any, preloadedState = initialState) => {
  return createStore(
    rootReducer,
    preloadedState,
    composeEnhancers(applyMiddleware(thunk))
  );
};
export default initializeStore;
